import allFonts from 'google-fonts-complete';
import { concat, filter, first } from '../Iterable';
import { IFontItem } from './FontLoader';

const webSafe =
{
    "Arial": { category: 'sans-serif' },
    "Verdana": { category: 'sans-serif' },
    "Tahoma": { category: 'sans-serif' },
    "Trebuchet MS": { category: 'sans-serif' },
    "Times New Roman": { category: 'serif' },
    "Georgia": { category: 'serif' },
    "Courier New": { category: 'monospace' },
    "Lucida Console": { category: 'monospace' },
    "Palatino Linotype": { category: 'serif' },
    "Impact": { category: 'sans-serif' },
    "Comic Sans MS": { category: 'cursive' }
};

function fontSetToList(set: Record<string, { category: string }>, setName: string): IFontItem[]
{
    return Object.entries(set).map(([family, { category }]) => ({ set: setName, family, category }));
}

export class FontManager
{
    static instance = new FontManager();

    fonts =
    {
        webSafe,
        google: allFonts,
    };
    fontList = [...concat(fontSetToList(webSafe, 'webSafe'), fontSetToList(allFonts, 'google'))];

    filter({ family, category, count } : { family: string, category: string, count: number })
    {
        let items: Iterable<IFontItem> = this.fontList;
        items = category ? filter(items, item => item.category === category) : items;
        items = family ? filter(items, item => item.family.includes(family)) : items;
        return first(items, { count });
    }
}